import { TRANSITION } from '../actionTypes';
import * as progressTracker from '../../factories/progressTracker/progressTracker';

export const transition = (to, from) => {
  return {
    type: TRANSITION,
    payload: {
      to,
      from,
      visited: progressTracker.getVisitedTabs()
    }
  };
};
